import React from "react";
import { Box, IconButton, TableCell, TableRow, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import Chip from "@material-ui/core/Chip";
import { getSortableRulesRelatedExceptions } from "store/features/emailScheduler/overview";
import { Header, Table } from "components/Table";
import { useConfirmationDialog, useTableSort } from "hooks";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import {
    getEmailSchedulerExceptionsState,
    deleteSchedulerRuleException,
} from "store/features/emailScheduler/exceptions";
import { useExceptionDialog } from "components/ExceptionDialog/hooks/useExceptionDialog";
import { ExceptionDialog } from "components/ExceptionDialog/ExceptionDialog";
import { ConfirmationDialog } from "components/ConfirmationDialog/ConfirmationDialog";
import { ChipTableCell } from "components";

const exceptionsHeadCells = [
    { id: "exceptionName", numeric: false, disablePadding: false, label: "Exception name" },
    { id: "rules", numeric: false, disablePadding: false, label: "Rules" },
];

export const Exceptions: React.FC = () => {
    const dispatch = useDispatch();
    const relatedExceptions = useSelector(getSortableRulesRelatedExceptions);
    const { isDeleting } = useSelector(getEmailSchedulerExceptionsState);
    const { sortedFields, order, orderBy, toggleSort } = useTableSort(relatedExceptions, "exceptionName");
    const {
        confirmationId,
        isConfirmationOpen,
        handleOnOpen,
        handleOnClose,
        handleOnExited,
        handleOnConfirm,
    } = useConfirmationDialog((id) => dispatch(deleteSchedulerRuleException.request({ id: id as string })));
    const { isOpen, handleDialog, handleEditException, handleSubmit } = useExceptionDialog(handleOnClose);

    return (
        <>
            <Header title="Exceptions" />
            <Box p={2}>
                <Table headCells={exceptionsHeadCells} onSort={toggleSort} order={order} orderBy={orderBy}>
                    {sortedFields.map(({ exceptionName, rules }, index) => (
                        <TableRow key={`${exceptionName}_${index}`}>
                            <TableCell>{exceptionName}</TableCell>
                            <ChipTableCell padding="none">
                                {rules.map((rule, index) => (
                                    <Chip key={`${rule}_${index}`} label={rule} />
                                ))}
                            </ChipTableCell>
                            <TableCell align="right" padding="none">
                                <IconButton onClick={handleEditException(exceptionName)} disabled={isDeleting}>
                                    <EditIcon fontSize="small" color={isDeleting ? "disabled" : "primary"} />
                                </IconButton>

                                <IconButton onClick={handleOnOpen(exceptionName)} disabled={isDeleting}>
                                    <ClearIcon fontSize="small" color={isDeleting ? "disabled" : "error"} />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </Table>
            </Box>
            <ExceptionDialog isOpen={isOpen} onToggle={handleDialog} onSubmit={handleSubmit} />
            <ConfirmationDialog isOpen={isConfirmationOpen} onClose={handleOnConfirm} onExited={handleOnExited}>
                <Typography variant={"body2"}>Do you want do delete &quot;{confirmationId}&quot;?</Typography>
            </ConfirmationDialog>
        </>
    );
};
